// @ts-strict-ignore
import React from "react";
import Scrollspy from "react-scrollspy";
import scrollToElement from "utils/scrollToElement";

import {
  BodyContainer,
  LeftContent,
  RightContent,
  AnchorLinkContainer,
  AnchorLink,
  ArticleContainer,
  BackLink,
  FixedContent,
  CardContent
} from "./style";
import { useScrollSpyOnUpdate } from "utils/scrollSpyUpdate";
import TextLink from "components/parts/NextLink/TextLink";
import HoverUnderline from "components/parts/HoverUnderline";
import { Body } from "components/parts/Typography";
import { useTranslations } from "i18n";
import { FILES } from "i18n/constants";

type TwoColumnProps = {
  currentContents?: AnchorProps[];
  children: any;
  offset?: number;
  isDerivatives: boolean;
};

type AnchorProps = {
  anchor: string;
  url: string;
  isMainHeader: boolean;
};

const TwoColumnCard: React.FC<TwoColumnProps> = ({
  currentContents,
  children,
  offset = 70, //Offset height of navbar
  isDerivatives
}): JSX.Element | null => {
  const t = useTranslations(FILES.LEGAL);

  const { currentAnchor, scrollSpyUpdate } = useScrollSpyOnUpdate({
    initialState: "",
    debounceDelay: 250,
    querySelector: ".anchor-active a"
  });

  const handleClick = (e: Event, link: AnchorProps) => {
    e.preventDefault();
    scrollToElement(link.url, offset);
  };
  // Update Anchor Tags on Scroll.
  const scrollSelectorID = (currentContents || []).map((e) => e.url.substr(1));

  return (
    <BodyContainer>
      <LeftContent>
        <FixedContent>
          <TextLink href={isDerivatives ? "/artemis/legal" : "/legal"}>
            <BackLink>{t("goBackLink")}</BackLink>
          </TextLink>
          {scrollSelectorID.length > 0 && (
            <CardContent>
              <Scrollspy
                items={scrollSelectorID}
                offset={offset}
                currentClassName="anchor-active"
                scrolledPastClassName="anchor-past"
                onUpdate={scrollSpyUpdate}
              >
                {currentContents.map((link) => {
                  const isActive = link.url === currentAnchor;
                  return (
                    <AnchorLinkContainer
                      key={link.url + link.anchor}
                      onClick={(e) => handleClick(e, link)}
                      isSelected={isActive}
                    >
                      <AnchorLink
                        isSecondary={!link.isMainHeader}
                        href={link.url}
                      >
                        <Body size="md" semiBold={isActive} m="0">
                          <HoverUnderline active={isActive}>
                            {link.anchor}
                          </HoverUnderline>
                        </Body>
                      </AnchorLink>
                    </AnchorLinkContainer>
                  );
                })}
              </Scrollspy>
            </CardContent>
          )}
        </FixedContent>
      </LeftContent>
      <RightContent>
        <TextLink href={isDerivatives ? "/artemis/legal" : "/legal"}>
          <BackLink noDesktop>{t("goBackLink")}</BackLink>
        </TextLink>
        <ArticleContainer>{children}</ArticleContainer>
      </RightContent>
    </BodyContainer>
  );
};

export default TwoColumnCard;
